const routes = [
  {
    path: '/menu',
    name: 'menu',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/casos',
    name: 'menu.casos',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/dashboardview',
    name: 'menu.dashboardview',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/reportes',
    name: 'menu.reporteS',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/reportes',
    name: 'menu.reportes',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/cliente',
    name: 'menu.cliente',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/trabajodecampo',
    name: 'menu.trabajodecampo',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/agente',
    name: 'menu.agente',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/parametros',
    name: 'menu.parametros',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/producto',
    name: 'menu.producto',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/proceso',
    name: 'menu.proceso',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/gestioncasillas',
    name: 'menu.gestioncasillas',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/otros',
    name: 'menu.otros',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/reportesconfig',
    name: 'menu.reportesconfig',
    component: () => import('@/views/Menu/Menu')
  },
  {
    path: '/menu/calls',
    name: 'menu.calls',
    component: () => import('@/views/Menu/Menu')
  }

]

export default routes
